import {Router} from '@angular/router';
import { Component, OnInit } from '@angular/core';
import { ToastsManager } from 'ng2-toastr/ng2-toastr';
import { FormBuilder, FormGroup, Validators, FormControl } from '@angular/forms';
import { Logger } from 'angular2-logger/core';

import { DashboardService } from '../dashboard.service';
import { SharedService } from '../../shared/shared.service';
import { environment } from '../../../environments/environment';
import { NgxSpinnerService } from 'ngx-spinner';

//  Jquery imports
declare var jquery:any;
declare var $:any;

@Component({
	selector: 'app-changepass',
	templateUrl: './changepass.component.html'
})

export class ChangepassComponent implements OnInit {
	public form : FormGroup;
	//public load : boolean;

	constructor(
		private _dashboardService: DashboardService,
		private _sharedService: SharedService,
		private _router:Router,
    	public toastr: ToastsManager,
    	private logger : Logger,
		private fb : FormBuilder,
		private spinner: NgxSpinnerService
	){
		this.form = this.fb.group({
			oldPassword: ['',[Validators.required, Validators.minLength(6)]],
			newPassword: ['',[Validators.required, Validators.minLength(8)]],
			confirm: ['',[Validators.required, Validators.minLength(8)]],
	    });

	}


	ngOnInit () {

	}


	onEdit(){

		//this.load = true; // loading screen
		this.spinner.show();
		this.form.value.token = this._sharedService.getCookie("auth_token");


		this._dashboardService.changePassword(this.form.value).subscribe(
			data => {
				if(data.res == 0) {
					this.toastr.error(data.det, 'Error');
				} else {
					this.toastr.success('Contraseña cambiada con éxito!', 'Éxito!');
					// LOGOUT
				}
				//this.load = false;
				this.spinner.hide();
			},
			error => {
				//this.load = false;
				this.spinner.hide();
				this.toastr.error('La contraseña actual es incorrecta, por favor intente de nuevo', 'Error');
				this.logger.log(error);
			}
		);

	}

}



// WEBPACK FOOTER //
// /home/ec2-user/PasoAgentes/PA_frontend_routemobile/src/app/dashboard/changepass/changepass.component.ts